import { render } from "./IOSAppstoreUpgrade.vue?vue&type=template&id=d22dfa5c&scoped=true"
import script from "./IOSAppstoreUpgrade.vue?vue&type=script&lang=js"
export * from "./IOSAppstoreUpgrade.vue?vue&type=script&lang=js"

import "./IOSAppstoreUpgrade.vue?vue&type=style&index=0&id=d22dfa5c&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22dfa5c"]])

export default __exports__